module.exports = __webpack_public_path__ + "img/SideView_NormalLighting.c448770f.png";